/**
 * @function get selected language kay value
 * @param settingList regional list
 * @param currentLanguage user preffered language
 * @description This function returns the initial selected key based on the current language.
 * @returns
 */
export const getInitialSelectedKey = (
  settingList: Array<any>,
  currentLanguage: string
) => {
  try {
    const key = settingList?.find(
      (item: any) => item.languageCode == currentLanguage
    ).id;
    if (key) {
      return key;
    }
    return "";
  } catch (error) {
    const defaultKey = settingList?.find(
      (item: any) => item.isDefaultRegion
    ).id;
    if (defaultKey) {
      return defaultKey;
    }
    return "";
  }
};
